import DefaultLayout from './DefaultLayout.vue'
import SimpleLayout from './SimpleLayout.vue'

export default {
    DefaultLayout,
    SimpleLayout,
}